import { useLanguage } from './i18n';

const STRIPE_LANGUAGES = ['en', 'es', 'fr'];

export default function StripeLanguageNote() {
  const { lang, t } = useLanguage();
  if (STRIPE_LANGUAGES.includes(lang)) return null;
  return <p className="field-hint">{t('The payment page is run by Stripe and is shown in English, because Stripe does not offer your language yet.')}</p>;
}
